/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdistatuseventTable.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edistatusevent-table";

export class AutogenModelEdistatuseventTable<RowType extends ModelRow> extends Endpoint<RowType, RowEdistatuseventTableFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdistatuseventTable extends ModelRow<RowEdistatuseventTableFields> {
	constructor(values?: Partial<RowEdistatuseventTableFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdistatuseventTableFields {
	ack_xmit_method: string;
	agent_payee_id: string;
	allow_update: string;
	alt_partner_id: string;
	appt_confirmed: string;
	appt_date_field: string;
	appt_date_table: string;
	audit_cutoff_days: number;
	audit_interval: number;
	batch_method: string;
	batch_method_read_only: string;
	carrier_id: string;
	company_id: string;
	consolidates_stops: string;
	create_method: string;
	create_service_inc: string;
	create_svrfail: string;
	days_to_retain: number;
	default_delay_code: string;
	delay_req: string;
	depart_can_arrive: string;
	descr: string;
	dest_stop_no: string;
	direction: string;
	display_sequence: number;
	edi_comm_id: number;
	edi_reqdfldgroup_count: number;
	enf_batch_cont: string;
	enf_batch_cont_997: string;
	event_type: string;
	fa_threshold: number;
	filename: string;
	func_ack_filename: string;
	func_ack_st02_frmt: string;
	func_ack_tid: number;
	func_altpartner_id: string;
	func_comm_id: number;
	func_next_batch: number;
	func_partner_id: string;
	func_use_m_batch: string;
	func_version: string;
	grace_period: number;
	grace_period_hours: number;
	grace_period_minutes: number;
	hold_for_preverr: string;
	hold_type: string;
	id: string;
	ignore_map_errors: string;
	img_def_loc_dir: string;
	img_dir_local: string;
	img_document_types: string;
	img_filetype: string;
	img_required: string;
	individual_batch: string;
	intercompany: string;
	late_by_date_only: string;
	map_callin: string;
	map_comment: string;
	minimum_interval: number;
	next_batch: number;
	notes: string;
	orig_stop_no: string;
	partner_id: string;
	partner_name: string;
	pickup_pos_lead_time: number;
	pickup_pos_prev_delivered: string;
	pickup_pos_stop_option: string;
	posted_type: string;
	process_priority: number;
	remove_file: string;
	remove_func_ack: string;
	req_src: string;
	resend_ear_req_src: string;
	resend_early_grace: number;
	resend_early_grace_period_hours: number;
	resend_early_grace_period_minutes: number;
	resend_if_early: string;
	resend_if_late: string;
	resend_lat_req_src: string;
	resend_late_grace: number;
	resend_late_grace_period_hours: number;
	resend_late_grace_period_minutes: number;
	send_all_instances: string;
	send_func_ack: string;
	send_to_company: string;
	send_update: string;
	show_on_rpt: string;
	skip_manual_orders: string;
	special_processing: string;
	st02_format: string;
	status_code: string;
	status_date_field: string;
	status_date_table: string;
	status_on_delivery: string;
	status_on_pickup: string;
	status_required: string;
	stop_type: string;
	template_id: number;
	time_required: string;
	transaction_set: string;
	transmit_method: string;
	un_delay_cross_ref: string;
	update_conf_appt: string;
	update_stop: string;
	update_stop_pieces: string;
	update_stop_weight: string;
	use_master_batch: string;
	use_show_as: string;
	version: string;
	xmit_sequence: number;
}

